<template lang="pug">
  .vacancy-preview(:class="{'top': top, 'lined': closed}")
    router-link(:to="{name: 'Vacancy', params: {lang: getLanguage, id: offer.id, previous: $route}}")
      p.item-id
        span {{ gettext('ID') }}: &nbsp;
        | {{ offer.id }}
      .img-wrap.small
        .partner(v-if="offer.is_partner") P
        .mdi.mdi-verified.icon-shield
        img(:src="image")
        .btn-get {{ gettext('Top Vacancy') }}
        .red-lined
      p.type {{ (offer.country || {}).short_name }}, {{(offer.region || {}).short_name}},&nbsp;
        | {{((offer.sector || {}).name)}}
      p.type
        span {{ gettext('Type') }}: {{ offer.employment_type.name }}
      p.type.from {{ gettext('From') }}
      p.type.price {{ `${offer.salary} ${(offer.currency || {}).code}` }}&nbsp;
        span / {{salaryTypeName(offer.salary_type)}}

      p.type(v-if="offer.profession || offer.other_profession") {{ gettext('Profession')+': ' }}
        span {{ ((offer.profession || {}).name) || offer.other_profession }}
      p.start-date(v-if="offer.start_date") {{ `${gettext('Start date')}: `}}
        span {{offer.start_date | format}}
      p.posted {{ `${gettext('posted')}: `}}
        span {{offer.updated_dt | format}} ({{offer.updated_dt | ago}})
    router-link.main-btn.col-white.bg-red.btn-more(:to="{name: 'Vacancy', params: {lang: getLanguage, id: offer.id, previous: $route}}") {{ gettext('See more') }}
</template>

<script>
import { mapGetters } from 'vuex'
import { gettext } from '@/services/TranslateHandler'
import timeago from 'timeago.js'
const CONSTANTS = require('@/constants.json')

const moment = require('moment')

export default {
  name: 'VacancyPreview',
  props: {
    top: {
      default: false
    },
    offer: {
      default: () => {
        return {}
      }
    },
    allCategories: {
      default () {
        return []
      }
    },
    closed: {
      default: false
    }
  },
  filters: {
    format: function (val) {
      return moment(val).format('DD.MM.YYYY')
    },
    ago: function (val) {
      let gettextLocal = (number, index, total) => {
        return [
          [gettext('just now'), gettext('right now')],
          [gettext('%s seconds ago'), gettext('in %s seconds')],
          [gettext('1 minute ago'), gettext('in 1 minute')],
          [gettext('%s minutes ago'), gettext('in %s minutes')],
          [gettext('1 hour ago'), gettext('in 1 hour')],
          [gettext('%s hours ago'), gettext('in %s hours')],
          [gettext('1 day ago'), gettext('in 1 day')],
          [gettext('%s days ago'), gettext('in %s days')],
          [gettext('1 week ago'), gettext('in 1 week')],
          [gettext('%s weeks ago'), gettext('in %s weeks')],
          [gettext('1 month ago'), gettext('in 1 month')],
          [gettext('%s months ago'), gettext('in %s months')],
          [gettext('1 year ago'), gettext('in 1 year')],
          [gettext('%s years ago'), gettext('in %s years')]
        ][index]
      }
      timeago.register('gettextLocal', gettextLocal)
      return timeago().format(val, 'gettextLocal')
    }
  },
  methods: {
    gettext: gettext,
    salaryTypeName (code) {
      let types = {
        [CONSTANTS.SALARY_PER_HOUR]: gettext('per hour'),
        [CONSTANTS.SALARY_PER_DAY]: gettext('per day'),
        [CONSTANTS.SALARY_PER_WEEK]: gettext('per week'),
        [CONSTANTS.SALARY_PER_MONTH]: gettext('per month')
      }
      if (code) return types[code]
      return types[CONSTANTS.SALARY_PER_HOUR]
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    image () {
      try {
        if (this.offer.image_urls && this.offer.image_urls.wide_mid) {
          return this.offer.image_urls.wide_mid
        }
        if (this.offer.employer.companylogo_urls && this.offer.employer.companylogo_urls.wide_max) {
          return this.offer.employer.companylogo_urls.wide_max
        }
        if (this.allCategories.filter(x => x.id === this.offer.category.id)[0].image) {
          return this.allCategories.filter(x => x.id === this.offer.category.id)[0].image
        }
        return '/webapp/images/companies/default-logo.png'
      } catch (e) {
        return '/webapp/images/companies/default-logo.png'
      }
    }
  }
}
</script>

<style lang='scss' scoped>
  h3{
    font-size: 18px;
    font-weight: 300;
  }
  .img-wrap {
    width: 226px;
    max-height: 140px;
  }
  .vacancy-preview {
    p {
      &.price{
        font-size: 18px;
        color: #bb1d2c !important;
      }
      &.item-id {
        color: #262a40;
        text-align: end;
        span {
          font-weight: bold;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/search/find-job/parts/vacancy-preview/index.vue